/**
 * Notification actions script file
 *
 * @package    Actions
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

export const ADD_NOTIFY = 'ADD_NOTIFY';
export const REMOVE_NOTIFY = 'REMOVE_NOTIFY';

/**
 * Add notify
 *
 * @param {String} message
 * @param {String} type
 *
 * @returns {Object}
 */
export function addNotify (message, type = 'success') {
    const id = Date.now();

    return function (dispatch) {
        return dispatch({
            data: {
                id,
                message,
                type,
            },
            type: ADD_NOTIFY,
        });
    };
}

/**
 * Add notify
 *
 * @param {Number} id
 *
 * @returns {Object}
 */
export function removeNotify (id) {
    return {
        id,
        type: REMOVE_NOTIFY,
    };
}
